import {
  IconBox,
  IconBuildingStore,
  IconChartBar,
  IconFileText,
  IconHome,
  IconId,
  IconRobot,
  IconSettings,
  IconUser,
  IconUsers,
  IconUserShield,
  type Icon,
} from '@tabler/icons-react';
import type { components } from '../shared/api/types.gen';

type UserRole = components['schemas']['UserRole'];

export type NavGroupKey = 'home' | 'content' | 'resource';

export type RouteMeta = {
  to: string;
  title: string;
  icon: Icon;
  group: NavGroupKey;
  // 지정 시 해당 role만 메뉴 노출(미지정=전체). 실제 차단은 백엔드.
  roles?: UserRole[];
};

// 라우터·사이드바가 공유하는 단일 라우트 메타 (경로·제목·아이콘·그룹).
export const ROUTES: RouteMeta[] = [
  { to: '/', title: '홈', icon: IconHome, group: 'home' },
  { to: '/products', title: '제품 관리', icon: IconBox, group: 'content' },
  { to: '/keywords', title: '키워드 & 글', icon: IconFileText, group: 'content' },
  { to: '/stats', title: '통계/현황', icon: IconChartBar, group: 'content' },
  { to: '/cafes', title: '카페 관리', icon: IconBuildingStore, group: 'resource' },
  { to: '/accounts', title: '계정 관리', icon: IconUsers, group: 'resource' },
  { to: '/workers', title: '워커 관리', icon: IconRobot, group: 'resource' },
  { to: '/nicknames', title: '닉네임 풀', icon: IconId, group: 'resource' },
  {
    to: '/users',
    title: '사용자 관리',
    icon: IconUserShield,
    group: 'resource',
    roles: ['MASTER', 'ADMIN'],
  },
  { to: '/me', title: '내 정보', icon: IconUser, group: 'resource' },
  { to: '/settings', title: '설정', icon: IconSettings, group: 'resource' },
];
